module.exports = __webpack_public_path__ + "img/gabriel_fandini.eab72e7d.png";